import React from 'react';
import { Loading } from '@roo/roo';
import PersonInfo from './person';
import StudyInfo from './study';
import ApplyInfo from './apply';
import { useSimpleContext } from '../_context';

import './index.scss';

const Scientist = () => {
  const {
    state: {
      step,
      loading,
    },
  } = useSimpleContext((s) => [s.step, s.loading]);

  if (loading) {
    return <Loading backdrop fullscreen visible={loading} />;
  }

  const formViews = [null, PersonInfo, StudyInfo, ApplyInfo];
  const FormView = formViews[step];

  return (
    <div className="scientist apply">
      <FormView />
    </div>
  );
};

export default Scientist;
